import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Biggen } from "../directives/biggen";
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-shroud-of-turin',
  imports: [Biggen, Link, RouterLink],
  templateUrl: './shroud-of-turin.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './shroud-of-turin.scss',
})
export class ShroudOfTurin {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Shroud of Turin`);
    this.dynamicTitle.description(`The Shroud of Turin is a piece of linen cloth bearing the image of a man. It is claimed by some to be the burial shroud of Jesus, but it is a medieval forgery.`);
  }
}
